import { Line }   from "../../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import RiotEventManager from 'utilities/riot/event_manager';
import { Global, LineCalendarCell, LineSelectedCell } from 'mixs/orders/planner/model';
import { PLANNER_CLICK_CELL } from 'apps/events';
class LineUICells extends Line {
  cells: LineCalendarCell[];
  cell: LineCalendarCell;
  cellTag: HTMLElement;
  em: RiotEventManager;
  onMouseMoveEvent: (e) => void;
  init(){
    super.init();
    // this.updateCells();
    this.cells = this.getPlannerData().cells;
    this.em = new RiotEventManager(this)
    this.listenMount([this.onMountLineUICells])
    this.onMouseMoveEvent = (e) => { this.onMouseMove(e); }
  }
  onMountLineUICells(){
    this.cellTag = this.querySelector('.cell') as HTMLElement;
  }
  updateCells(){
    // this.update();
  }
  onOver(e){
    e.preventUpdate = false;
    this.em.customEvent('mousemove', this.onMouseMoveEvent);
    this.setCell(e);
  }
  onMouseMove(e){
    this.setCell(e);
  }
  onOut(e){
    e.preventUpdate = false;
    this.em.removeCustomEvent('mousemove', this.onMouseMoveEvent);
    this.unsetCell(e);
  }
  setCell(e){
    let num = Math.floor(e.layerX / Global.cellWidth)
    let left = Global.cellWidth * num;
    this.cell = this.cells[num];
    this.cellTag.style.left = left + 'px';
    this.cellTag.style.display = 'block';
  }
  unsetCell(e){
    this.cell = null;
    this.cellTag.style.display = 'none';
  }
  onClick(e){
    e.preventUpdate = false;
    let selectedCell: LineSelectedCell = new LineSelectedCell(this.opts.id, this.cell, this.cellTag);
    let customEvent = new CustomEvent(PLANNER_CLICK_CELL, { detail: selectedCell });
    document.dispatchEvent(customEvent);
  }
}
riot.mixin('orders.planner.line-ui.cells', LineUICells as riot.TagMixin)
